/**
 * Created by vladislav on 1/18/19
 */

ColorBombCell.prototype.hurtDuration = function () {
    return 0.0;
};